import { Component, OnInit } from '@angular/core';
import { BaseReportCardComponent } from '../base-report-card.component';
import { CustomerIssuesViewModel, ReportGenSvc, ReportWithDatesRequest } from 'src/app/services_autogenerated/generated_services';
import { Router } from '@angular/router';

@Component({
    selector: 'app-customer-issues',
    templateUrl: './customer-issues.component.html',
    styleUrls: ['./customer-issues.component.css'],
    standalone: false
})
export class CustomerIssuesComponent extends BaseReportCardComponent implements OnInit {
  issuesLoading: boolean = true;
  issues: CustomerIssuesViewModel[];

  constructor(private reportService: ReportGenSvc,
  ) {
    super();
  }

  ngOnInit() {
    this.reportService.getCustomerIssues(new ReportWithDatesRequest({
        id: !this.companyWide ? this.employee.id : null}))
      .subscribe(res => {
      this.issues = res;
      this.issuesLoading = false;
    })
  }

  goToWorkOrder(issue: CustomerIssuesViewModel) {
    window.open(issue.link, '_blank');
  }
}
